import styled from 'styled-components'
import { CSS } from 'ui/helpers'

export const Subtitle = styled.div`
  ${(p) => CSS.populateFont(p.theme.uiKit.typography.bodyL.regular)}
`
